import { useState } from 'react'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import PublicAppHeader from '../PublicAppHeader'
import { PublicAppFooter } from '../PublicAppFooter'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import { ShadeBackgroundForPublicPagesVariantOne } from '../ListingPageComponentsAndHelpers/ListingPageComponents'

export default function AboutPage() {
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  return (
    <>
      <SEOComponent
        title="About AUMHUM | AUMHUM"
        description="Learn about AUMHUM - a digital mental health and emotional wellness platform designed to support individuals, families, and clinicians through structured therapy programs, assessments, and guided care journeys."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['about', 'aumhum', 'mental health', 'wellness']}
      />
      <PublicAppHeader
        config={{ showLinks: true }}
        loginFunction={() => {
          setTypeOfClubbedAuthModal('login')
          setShowClubbedAuthModal(true)
        }}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
      />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
      />
      <ShadeBackgroundForPublicPagesVariantOne>
        <div
          style={{
            margin: '80px auto',
            maxWidth: '800px',
            padding: '40px 20px',
            fontFamily: 'Outfit, sans-serif',
            fontSize: '16px',
            fontWeight: '300',
            color: '#636363',
            lineHeight: '1.6',
            minHeight: 'calc(100vh - 200px)',
          }}
        >
          <h1
            style={{
              fontSize: '2rem',
              fontWeight: '500',
              marginBottom: '1.5rem',
              color: '#1c1c1c',
            }}
          >
            About AUMHUM
          </h1>

          <div style={{ marginBottom: '2rem' }}>
            <h2
              style={{
                fontSize: '1.25rem',
                fontWeight: '500',
                marginBottom: '1rem',
                marginTop: '2rem',
                color: '#1c1c1c',
              }}
            >
              What is AUMHUM?
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              AUMHUM is a digital mental health and emotional wellness platform designed to support
              individuals, families, and clinicians through structured therapy programs, assessments,
              and guided care journeys.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              Users can securely sign in to the platform to access their personalized wellness tools,
              session information, and clinical resources. Google Sign-In is used solely to simplify
              authentication and ensure a secure login experience. AUMHUM only accesses basic profile
              information required for account identification and does not use Google data for
              advertising or unauthorized purposes.
            </p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2
              style={{
                fontSize: '1.25rem',
                fontWeight: '500',
                marginBottom: '1rem',
                marginTop: '2rem',
                color: '#1c1c1c',
              }}
            >
              Our Mission
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              We&rsquo;re a small, experienced team that comes from years of technology, mobility, care,
              sports, meditation, yoga and fitness background.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              Our mission is to make the world a healthier and more wholesome place where every emotion
              is accepted, not just happiness. Not by educating or lecturing people, nor by treating
              them in a clinic. Instead, we combine access, knowledge, technology and humans to deliver
              compelling consumer services that make everyday healthy living sustainable and wholesome.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              Our team comes from a diverse range of backgrounds and meditation practice levels. What we
              all share is a passion and excitement to build something truly meaningful.
            </p>
          </div>
        </div>
      </ShadeBackgroundForPublicPagesVariantOne>
      <PublicAppFooter />
    </>
  )
}
